import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-333eb268"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-9" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-1" }, null, -1))
const _hoisted_3 = { class: "sm:col-span-5 main-content" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "w-64 justify-items-stretch flex flex-col mt-8" }
const _hoisted_6 = ["value", "selected"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 0,
  class: "bottom-0 absolute p-2 sm:max-w-half"
}
const _hoisted_12 = ["href", "innerHTML"]
const _hoisted_13 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActionButton = _resolveComponent("ActionButton")!
  const _component_Slider = _resolveComponent("Slider")!
  const _component_BackNextButtons = _resolveComponent("BackNextButtons")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["screen-content", _ctx.config.classes?.wrapperClasses])
  }, [
    _createVNode(_component_ScreenWrapper, {
      "class-name": "pt-0",
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", {
              class: "text-3xl font-medium",
              innerHTML: _ctx.$rt(_ctx.config.title, {name: _ctx.state.nickname.value})
            }, null, 8, _hoisted_4),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("select", {
                class: "answer-button mb-4 w-64 bg-project text-white",
                onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.answer($event.target.value, _ctx.config.answerKeys.country, {
                      [_ctx.config.answerKeys.country]: _ctx.config.title,
                    })))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (label, code) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: code,
                    key: code,
                    selected: _ctx.selectedCountry === code
                  }, _toDisplayString(label), 9, _hoisted_6))
                }), 128))
              ], 32)
            ]),
            _createElementVNode("h3", {
              class: "mt-12 text-3xl font-medium",
              innerHTML: _ctx.$rt('What is you gender?')
            }, null, 8, _hoisted_7),
            _createElementVNode("div", {
              class: _normalizeClass(["mt-8 justify-items-stretch flex flex-col", {['grid-flow-col-dense grid-rows-'+_ctx.config.maxRows]: _ctx.config.maxRows}])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.options.gender, (option, key) => {
                return (_openBlock(), _createBlock(_component_ActionButton, {
                  key: key,
                  selected: _ctx.state.answers.value?.[_ctx.config.answerKeys.gender] === key,
                  class: _normalizeClass(["options-button mb-4 text-left w-64", _ctx.config.classes?.buttonClasses]),
                  "button-class": "answer-button",
                  onClick: ($event: any) => (_ctx.answer(key, _ctx.config.answerKeys.gender, {
                 [_ctx.config.answerKeys.gender]: 'What is you gender?',
                  [key]: _ctx.$t(option)
                })),
                  rawtext: _ctx.$t(option)
                }, null, 8, ["selected", "class", "onClick", "rawtext"]))
              }), 128))
            ], 2),
            _createElementVNode("h3", {
              class: "mt-12 text-3xl font-medium",
              innerHTML: _ctx.$rt('What is you age group?')
            }, null, 8, _hoisted_8),
            _createElementVNode("div", {
              class: _normalizeClass(["mt-8 justify-items-stretch flex flex-col", {['grid-flow-col-dense grid-rows-'+_ctx.config.maxRows]: _ctx.config.maxRows}])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.options.age, (option, key) => {
                return (_openBlock(), _createBlock(_component_ActionButton, {
                  key: key,
                  selected: _ctx.state.answers.value?.[_ctx.config.answerKeys.age] === key,
                  class: _normalizeClass(["options-button mb-4 text-left w-64", _ctx.config.classes?.buttonClasses]),
                  "button-class": "answer-button",
                  onClick: ($event: any) => (_ctx.answer(key, _ctx.config.answerKeys.age, {
                  [_ctx.config.answerKeys.age]: 'What is you age group?',
                  [key]: _ctx.$t(option),
                })),
                  rawtext: _ctx.$t(option)
                }, null, 8, ["selected", "class", "onClick", "rawtext"]))
              }), 128))
            ], 2),
            _createElementVNode("h3", {
              class: "mt-12 text-3xl font-medium",
              innerHTML: _ctx.$rt(_ctx.config.question, {name: _ctx.state.nickname.value})
            }, null, 8, _hoisted_9),
            _createVNode(_component_Slider, {
              class: _normalizeClass(["w-full md:w-3/4 mt-8 mb-12", _ctx.config.classes?.sliderClass]),
              options: _ctx.config.answerOptions,
              min: _ctx.config.answerMin,
              max: _ctx.config.answerMax,
              step: _ctx.config.answerStep,
              value: _ctx.state.answers.value?.[_ctx.config.answerKey],
              unit: _ctx.$t(_ctx.config.answerUnit, {name: _ctx.state.nickname.value}),
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.answer( $event, _ctx.config.answerKey, { [_ctx.config.answerKey]: `${_ctx.$rt(_ctx.config.question)}`, [$event]: _ctx.$t(_ctx.config.answerOptions[$event]) }))),
              alternate: _ctx.config.sliderAlternate
            }, null, 8, ["options", "min", "max", "step", "value", "unit", "class", "alternate"]),
            _createVNode(_component_BackNextButtons, {
              class: "mt-12",
              "go-to": _ctx.goTo,
              "next-screen": _ctx.config.screenNext
            }, null, 8, ["go-to", "next-screen"])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["sm:col-span-3 h-full min-h-50vh flex flex-col items-center justify-center", _ctx.config.classes.rightSide])
          }, [
            (_ctx.config.bgImage)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "bg-project w-full p-16 aspect-square flex flex-col items-center justify-center",
                  style: _normalizeStyle(_ctx.config.bgStyles)
                }, [
                  _createElementVNode("img", {
                    src: _ctx.config.bgImage,
                    class: _normalizeClass(["w-full", _ctx.config.classes?.bgImageClasses]),
                    alt: "Logo"
                  }, null, 10, _hoisted_10)
                ], 4))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        (_ctx.config.source)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_ctx.config.source.link)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: _ctx.$t(_ctx.config.source.link),
                    class: "text-xs text-gray-900 hover:text-gray-400",
                    target: "_blank",
                    innerHTML: _ctx.$t(_ctx.config.source.text, {name: _ctx.state.nickname.value})
                  }, null, 8, _hoisted_12))
                : (_openBlock(), _createElementBlock("p", {
                    key: 1,
                    class: "text-xs",
                    innerHTML: _ctx.$t(_ctx.config.source.text, {name: _ctx.state.nickname.value})
                  }, null, 8, _hoisted_13))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["next", "screen"])
  ], 2))
}